import { Input } from "@progress/kendo-react-inputs";

export const MarginProperty = {
  propertyName: "margin",
  propertyDisplay: "Margin",
  propertyType: "number",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <div
        className="align-rows"
        style={{ marginLeft: 0, paddingLeft: 20 }}
      >
        <div className="align-columns">
          <div>
            <Input
              label="top"
              type="number"
              name={"marginTop"}
              disabled={currentPropertyValues?.IsTab}
              onBlur={(e) => {
                handlePropertyChange({ propName: "marginTop", propValue: e.target.value });
              }}
              defaultValue={
                currentPropertyValues?.IsTab ? "" : currentPropertyValues?.marginTop || ""
              }
            />
            <Input
              label="left"
              type="number"
              name={"marginLeft"}
              disabled={currentPropertyValues?.IsTab}
              onBlur={(e) => {
                handlePropertyChange({ propName: "marginLeft", propValue: e.target.value });
              }}
              defaultValue={
                currentPropertyValues?.IsTab ? "" : currentPropertyValues?.marginLeft || ""
              }
            />
          </div>
          <div>
            <Input
              label="bottom"
              type="number"
              name={"marginBottom"}
              disabled={currentPropertyValues?.IsTab}
              onBlur={(e) => {
                handlePropertyChange({ propName: "marginBottom", propValue: e.target.value });
              }}
              defaultValue={
                currentPropertyValues?.IsTab ? "" : currentPropertyValues?.marginBottom || ""
              }
            />
            <Input
              label="right"
              type="number"
              name={"marginRight"}
              disabled={currentPropertyValues?.IsTab}
              onBlur={(e) => {
                handlePropertyChange({ propName: "marginRight", propValue: e.target.value });
              }}
              defaultValue={
                currentPropertyValues?.IsTab ? "" : currentPropertyValues?.marginRight || ""
              }
            />
          </div>
        </div>
      </div>
    );
  },
};
